import { Trans, useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';

const GoogleApiServiceLink =
  'https://developers.google.com/terms/api-services-user-data-policy';

interface Props {
  /** Set from `IntegrationMeta.requiresGooglePolicyNotice` — true for googleAds/GA4/CM. */
  requiresGooglePolicyNotice?: boolean;
}

export const PolicyMessage = ({ requiresGooglePolicyNotice }: Props) => {
  const { t } = useTranslation('@mint-lib/connections-ui');

  if (!requiresGooglePolicyNotice) return null;

  return (
    <p
      className={typographyVariants({
        variant: 'caption2',
        color: 'secondary',
      })}
    >
      <Trans
        t={t}
        i18nKey="MINT ARM's use and transfer of information received from Google APIs to any other app will adhere to <Link />, including the Limited Use requirements."
        components={{
          Link: (
            <a
              href={GoogleApiServiceLink}
              target="_blank"
              rel="noreferrer"
              className={typographyVariants({
                variant: 'caption2',
                color: 'link',
              })}
            >
              {t('Google API Services User Data Policy')}
            </a>
          ),
        }}
      />
    </p>
  );
};
